export default __webpack_public_path__ + "static/media/audit.b37df8a2.png";